export default "/images/11 Step2Plan-Consultant-To view completed self-assessments-03.png?0a3f845c94e2257c16f3d5e401b35307";